import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'

import Outbound from '../views/Outbound.vue'
import SpecialOrders from '../views/SpecialOrders.vue'
import Invoices from '../views/Invoices.vue'
import Clients from '../views/Clients.vue'
import Products from '../views/Products.vue'
import ProductDetail from '../views/ProductDetail.vue'

// Special
import SpecialDetail from '@/views/SpecialDetail.vue'

// Transport
import Transport from '../views/Transport.vue'
import TransportDetail from '../views/TransportDetail.vue'

// Inbound
import Inbound from '../views/Inbound.vue'
import Inbound2 from '../views/Inbound2.vue'
import InboundDetail from '@/views/InboundDetail.vue'
import NewInboundOrder from '../components/inbound/New.vue'
import PutAway from '../components/inbound/PutAway.vue'

import NewOutboundOrder from '../components/outbound/New.vue'
import PageNotFound from '../views/PageNotFound.vue'

import Settings from '../views/Settings.vue'
import SettingsEmailTemplates from '../views/SettingsEmailTemplates.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard
  },

  {
    path: '/inbound/:id(\\d+)',
    name: 'inbound-detail',
    component: InboundDetail
  },

  {
    path: '/inbound/:id(\\d+)/put-away',
    name: 'inbound-put-away',
    component: PutAway
  },

  {
    path: '/inbound/new',
    name: 'new-inbound',
    component: NewInboundOrder
  },

  {
    path: '/inbound2/:status?',
    name: 'inbound2',
    component: Inbound2
  },

  {
    path: '/inbound/:status?/:id?',
    name: 'inbound',
    component: Inbound
  },

  {
    path: '/outbound/new',
    name: 'new-outbound',
    component: NewOutboundOrder
  },

  {
    path: '/outbound/:status?/:id?',
    name: 'outbound',
    component: Outbound
  },

  {
    path: '/special/:id(\\d+)',
    name: 'special-detail',
    component: SpecialDetail
  },

  {
    path: '/special-orders/:status?/:id?',
    name: 'special-orders',
    component: SpecialOrders
  },
  {
    path: '/transport',
    name: 'transport',
    component: Transport
  },
  
  {
    path: '/transport/:id(\\d+)',
    name: 'transport-detail',
    component: TransportDetail
  },

  {
    path: '/invoices/:id(\\d+)',
    name: 'invoice-detail',
    component: Invoices
  },

  {
    path: '/invoices/:status?',
    name: 'invoice',
    component: Invoices
  },

  {
    path: '/clients/:id?',
    name: 'clients',
    component: Clients
  },

  {
    path: '/products',
    name: 'products',
    component: Products
  },

  {
    path: '/products/:id',
    name: 'products-detail',
    component: ProductDetail
  },

  {
    path: '/settings',
    name: 'settings',
    component: Settings,

    children: [
      { path: 'email-templates', component: SettingsEmailTemplates }
    ]
  },
  { path: '/', redirect: '/dashboard' },
  { path: "*", component: PageNotFound },
]

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  routes
})

export default router
